import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors";
import { RedDotComponent } from "./index";
import { Channel, Topic } from "../../constants";
import { UserContextActionCreators } from "../../redux/action-creators";
import { MessageBrokerUtils } from "../../utils";

export const TicketsRedDot = props => {
  const { mobileClassName, dataTestId } = props;
  const { totalTicketCount, unreadCount } = useSelector(
    UserContextSelectors.userTickets
  );
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const dispatch = useDispatch();

  const processTicketOpen = useCallback(() => {
    dispatch(UserContextActionCreators.allTicketsSeen());
  }, [dispatch]);

  useEffect(() => {
    const trtSubscription = MessageBrokerUtils.subscribe({
      channel: Channel.CRM,
      topic: Topic.TOURNAMENT_TICKETS_TAB_OPENED,
      callback: processTicketOpen
    });

    return () => {
      trtSubscription?.unsubscribe();
    };
  }, [processTicketOpen]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <RedDotComponent
      unreadNotificationCount={unreadCount}
      totalNotificationCount={totalTicketCount}
      mobileClassName={mobileClassName}
      dataTestId={dataTestId}
    />
  );
};

TicketsRedDot.propTypes = {
  mobileClassName: PropTypes.string,
  dataTestId: PropTypes.string.isRequired
};
